import { createFileRoute } from '@tanstack/react-router';
import { AddTicketFlow } from '@/features/tracking/AddTicketFlow.tsx';
import { requireAuth } from '@/features/auth/guard.ts';

const KINDS = ['flight', 'train', 'bus'] as const;

export const Route = createFileRoute('/_app/add-ticket')({
  validateSearch: (s: Record<string, unknown>): { trip?: string; kind?: (typeof KINDS)[number] } => ({
    ...(typeof s.trip === 'string' ? { trip: s.trip } : {}),
    ...(KINDS.includes(s.kind as never) ? { kind: s.kind as (typeof KINDS)[number] } : {}),
  }),
  beforeLoad: requireAuth,
  component: AddTicketRoute,
});

function AddTicketRoute() {
  const { trip, kind } = Route.useSearch();
  return <AddTicketFlow tripId={trip} initialKind={kind} />;
}
